
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeTugOutlined as ObiVesselTypeTugOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-tug-outlined.js';
 
 
 

 
 export const ObiVesselTypeTugOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-tug-outlined',
   elementClass: ObiVesselTypeTugOutlinedElement,
   events: {
     
   }
  });
 
 